import { getField, updateField } from 'vuex-map-fields'
import api from '@/api/api'
import { Supervisor } from '@/models/Supervisor'
import Swal from 'sweetalert2'
import { supervisorTransformer } from '@/utils/transformers'

export const SET_STATE = 'SET_STATE'
export const BOOTSTRAP_PROFILE = 'BOOTSTRAP_PROFILE'
export const LOAD_ROLES = 'LOAD_ROLES'
export const LOAD_GESTORES = 'LOAD_GESTORES'
export const LOAD_UNIDADES_NEGOCIO = 'LOAD_UNIDADES_NEGOCIO'
export const SUBMIT = 'SUBMIT'
export const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    gestores: [],
    uNegocio: [],
    roles: [],
    step: 1,
    loading: true,
    isEditing: false,
    dialog: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
  gestores: state => state.gestores,
  isEditing: state => state.isEditing,
}

const mutations = {
  updateField,
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
}

const actions = {
  async [BOOTSTRAP_PROFILE] ({ dispatch, commit, state }, { id }) {
    commit(RESET_STATE)
    commit(SET_STATE, { loading: true, isEditing: false })
    dispatch('form/BOOTSTRAP_FORM', { model: new Supervisor() }, { root: true })
    await dispatch(LOAD_GESTORES)
    await dispatch(LOAD_UNIDADES_NEGOCIO)
    await dispatch(LOAD_ROLES)
    if (id) {
      commit(SET_STATE, { isEditing: true })
      await api.getEntidade('supervisor', id).then(response => {
        commit(SET_STATE, { loading: false })
        dispatch('form/BOOTSTRAP_FORM', { model: new Supervisor(supervisorTransformer(response.data[0])) }, { root: true })
      })
    } else {
      commit(SET_STATE, { dialog: true, loading: false, isEditing: false })
    }
  },
  async [LOAD_ROLES] ({ dispatch, commit }) {
    await api.getEntidade('role', 7).then(
      response => {
        const roles = response.data
        commit(SET_STATE, { roles })
      },
    )
  },
  async [LOAD_GESTORES] ({ dispatch, commit }) {
    await api.listEntidade('gestor').then(
      gestores => {
        commit(SET_STATE, { gestores })
      },
    )
  },
  async [LOAD_UNIDADES_NEGOCIO] ({ dispatch, commit }) {
    await api.listEntidade('unidadeNegocio').then(
      uNegocio => {
        commit(SET_STATE, { uNegocio })
      },
    )
  },
  async [SUBMIT] ({ commit, dispatch, state, rootState }, { router, user }) {
    const form = { ...rootState.form.data, unidade: rootState.form.data.unidades }
    form.role_id = form.role
    if (form.data_nascimento) {
      const [day, month, year] = form.data_nascimento.split('/')
      form.data_nascimento = year + '-' + month + '-' + day
    }
    Swal.fire({
      title: 'Enviando dados!',
      timerProgressBar: true,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
      didOpen: () => {
        (() => {
          return state.isEditing
            ? api.salvarEntidade(form, 'supervisor', form.id)
            : api.cadastrarEntidade(form, 'supervisor')
        })().then(
          data => {
            window.Toast.fire(state.isEditing
              ? 'Supervisor atualizado com sucesso!'
              : 'Supervisor cadastrado com sucesso!', '', 'success')
            dispatch('supervisores/BOOTSTRAP', null, { root: true })
            router.push({
              path: `/${user.get().role}/supervisores`,
            })
          },
          error => {
            Swal.fire({
              icon: 'error',
              title: 'Atenção',
              text: error.errors ? error.errors : error.message,
            })
          },
        )
      },
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
